<template>   
<v-flex>        
    <v-container grid-list-md pa-0 v-if="windowSize.x > 1264">   
        
        <v-layout v-if="$store.state.menuLateralDrawer" row wrap hidden-md-and-down>                    
            <v-flex xs3 pa-0>
                <menulateral pa-0/>
            </v-flex>
            <v-flex xs9 pa-0>
                <listacatalogo/>
            </v-flex> 
        </v-layout>   
        <v-layout v-else row wrap hidden-md-and-down>                   
            <v-flex xs12 pa-0 >
                <listacatalogo/>
            </v-flex> 
        </v-layout>  
        <!-- Causa el error "Maximum call stack size exceeded. at VueComponent.onFocusin" al cargar de nuevo menulateral y listacatalogo-->
        <!--v-layout row wrap hidden-lg-and-up>      
            <menulateral pa-0/>                  
            <wall/>               
            <v-flex xs12 pa-0 >
                <listacatalogo/>
            </v-flex> 
        </v-layout-->
    </v-container>
    <v-container grid-list-md pa-0 v-if="(windowSize.x > 960) && (windowSize.x <= 1264)">   
        <v-layout row wrap hidden-lg-and-up>      
            <menulateral pa-0/>                  
            <wall/>               
            <v-flex xs12 pa-0 >
                <listacatalogo/>
            </v-flex> 
        </v-layout>
    </v-container>
    <v-container grid-list-md pa-0 v-if="windowSize.x <= 960" >           
        <menulateral pa-0/>                  
        <wall/>               
        <v-flex xs12 pa-0 >
            <listacatalogomobile/>
        </v-flex> 
    </v-container>
</v-flex>
</template>
<script>
import menulateral from "@/components/menulateral";
import listacatalogomobile from "@/components/listacatalogomobile";
import listacatalogo from "@/components/listacatalogo";
import wall from "@/components/wall";
import store from '@/store'

export default {
    name: 'Menu',
    components: {
        menulateral,
        listacatalogo,
        wall,
        listacatalogomobile
    },
    beforeRouteLeave (to, from, next) {      
        store.commit('setIsMenu',false);
        next()    
    },
    beforeRouteEnter (to, from, next) {
        store.commit('setIsMenu',true);
        store.state.docNameVisible = true;
        next(vm => {
            
        })
    },
     computed:{
        windowSize:{
            get(){
                    return this.$store.state.windowSize;
                },
                set(value){
                    this.$store.state.windowSize = value;
                }
        },
    }
}
</script>
<style scoped>
@media only screen and (max-width: 1920px){
    .container {
        max-width: 100% !important;
    }
}
#menuLateral,#listaCatalogo{
    padding: 0px !important;
}
#menuLateral{
    z-index: 100;
}
</style>
